import { TranslationService } from '../services/translation.service';
import { type ILocationAutocompleteSelection } from '../components/Shared/LocationAutocomplete';
import { LocationAutocompleteSelectionType } from '../components/Shared/LocationAutocomplete/location-autocomplete-selection-type.enum';
import { LocationType } from '../models/location-type.enum';

interface LocationParameters {
  gid: string | undefined;
  name: string | undefined;
  latitude: number | undefined;
  longitude: number | undefined;
}

export class JourneySearchHelper {
  public static getAnalyticsLabel(fromLocation: ILocationAutocompleteSelection | undefined, toLocation: ILocationAutocompleteSelection | undefined): string {
    return `Från: ${this.getAnalyticsLocationType(fromLocation)}; Till: ${this.getAnalyticsLocationType(toLocation)}`;
  }

  private static getAnalyticsLocationType(selection: ILocationAutocompleteSelection | undefined): string {
    if (selection?.type === LocationAutocompleteSelectionType.currentPosition) return 'Nuvarande position';

    switch (selection?.location?.locationType) {
      case LocationType.stopArea:
      case LocationType.stopPoint:
      case LocationType.metaStation:
        return 'Hållplats';
      case LocationType.address:
        return 'Adress';
      case LocationType.pointOfInterest:
        return 'POI';
      default:
        return 'Övrigt';
    }
  }

  public static getLocationParameters(locationSelection: ILocationAutocompleteSelection): LocationParameters {
    const isLocationType = locationSelection.type === LocationAutocompleteSelectionType.location;

    return {
      gid: isLocationType ? locationSelection.location?.gid : undefined,
      name: isLocationType ? locationSelection.location?.name : TranslationService.get('common.autocomplete.currentposition'),
      latitude: isLocationType ? locationSelection.location?.latitude : locationSelection.coordinates?.latitude,
      longitude: isLocationType ? locationSelection.location?.longitude : locationSelection.coordinates?.longitude,
    };
  }
}
